export enum DefaultPolicyColumnKeys {
  POSITION = 'defaultPositionInGrid',
}
